export enum AlertTypeEnum {
  systemTempPaused = 'systemTempPaused',
  costGt80Influencer = 'costGt80Influencer',
  costGt80Affiliate = 'costGt80Affiliate',
  reviewApproved = 'reviewApproved',
  reviewRejected = 'reviewRejected',
}
